import styled from 'styled-components'

export const TextWithFeatureImageWrapper = styled.section`
  h3 {
    &:after {
      content: '';
      display: block;
      height: 1px;
      background-color: ${props => props.theme.colors.cobalt};
      max-width: 25rem;
      margin: 2rem auto 0;
    }
  }
  text-align: center;
  ul {
    display: flex;
    margin-top: 5rem;
    flex-wrap: wrap;
    flex-direction: column;
    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      flex-direction: row;

      &.center-block {
        justify-content: center;
      }
    }
  }

  li {
    flex: 1 0 23%;
    text-align: left;
    position: relative;
    margin-bottom: 2rem;
    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      max-width: calc(33.33% - 3.2rem);
      margin-right: 3.2rem;
    }
    div {
      color: ${props => props.theme.colors.white};
    }
    .description {
      position: absolute;
      text-align: center;
      top: 50%;
      transform: translate(-50%, -50%);
      left: 50%;
      p {
        font-size: 1.4rem;
      }
    }
  }
`
